module.exports = "/assets/fonts/4cbfe750.jpg";